import { Outlet } from '@remix-run/react';
import BusinessManagerListener from '~/modules/business-manager/component/bm-listener/BusinessManagerListener';
import styles from '~/modules/business-manager/component/bm-listener/hide-userback.css?url';
import { ClientOnly } from 'remix-utils';
import PageLayout from '@modules/professional/component/page-layout/PageLayout';
import type { APHandle, HandleHideNavigation } from '@modules/root/type/handle';
import { useLoaderData } from '@remix-run/react';
import type { loader } from '@modules/professional/page/loaders/professional-page-preview-loader.server';

const hideNavigation: HandleHideNavigation = {
    desktop: true,
    tablet: true,
    mobile: true,
};

export const handle: APHandle = {
    hideTopNavigation: hideNavigation,
    hideFooter: hideNavigation,
    isBMPreview: true,
    hideContactArchiPro: true,
};
export const links = () => [
    {
        rel: 'stylesheet',
        href: styles,
    },
];

const EditorPreviewRootPage = () => {
    const { primaryCTA } = useLoaderData<typeof loader>();

    return (
        <div style={{ pointerEvents: 'none' }}>
            <PageLayout primaryCTA={primaryCTA}>
                <ClientOnly fallback={<></>}>
                    {() => {
                        return <BusinessManagerListener />;
                    }}
                </ClientOnly>

                <Outlet />
            </PageLayout>
        </div>
    );
};

export default EditorPreviewRootPage;
